module.exports = __webpack_public_path__ + "img/women-box02.c40c8bcf.png";